import { useEffect, useCallback } from 'react';

/**
 * @param callback: () => any
 * @param seconds: number - milliseconds
 * @param flag: boolean
 */
export function useInactivityTimer(
  callback: (params?: any) => any,
  seconds: number,
  flag = true
): boolean | void {
  const callbackFn = useCallback(callback, []);

  useEffect(() => {
    if (!flag) return;

    let timer = 0;
    const delay = 1000;
    const resetTimer = () => {
      timer = 0;
    };
    const DEFAULT_EVENTS = [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mouseWheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
    ];

    for (const event of DEFAULT_EVENTS) {
      window.addEventListener(event, resetTimer);
    }

    let interval: number;

    interval = window.setInterval(() => {
      timer++;
      if (timer >= seconds) {
        callbackFn();
      }
    }, delay);

    return () => {
      for (const event of DEFAULT_EVENTS) {
        window.removeEventListener(event, resetTimer);
      }
      window.clearInterval(interval);
    };
  }, [callbackFn, flag, seconds]);
}
